import axios from 'axios';
import { assertOwnedBackendRequest, apiOrigin } from './apiOrigin';

const MOCK_AUTH_ENABLED = import.meta.env.DEV && import.meta.env.VITE_MOCK_AUTH === 'true';
type TokenProvider = () => Promise<string>;
let session: { getToken: TokenProvider } | undefined;

/** Register an SDK session, never a persisted bearer. Cleanup revokes pending requests too. */
export function installAccessTokenProvider(getToken: TokenProvider): () => void {
  const installed = { getToken };
  session = installed;
  localStorage.removeItem('access_token');
  return () => { if (session === installed) session = undefined; };
}

const client = axios.create({ baseURL: apiOrigin, timeout: 10000 });
client.interceptors.request.use(async (config) => {
  assertOwnedBackendRequest(config.url, config.baseURL, apiOrigin);
  const active = session;
  if (!MOCK_AUTH_ENABLED && !active) throw new Error('Sign-in session is unavailable.');
  const token = MOCK_AUTH_ENABLED ? 'mock-token' : await active!.getToken();
  if (!MOCK_AUTH_ENABLED && (active !== session || !token)) {
    throw new Error('Sign-in session changed. Please sign in again.');
  }
  config.headers.set('Authorization', `Bearer ${token}`);
  return config;
});

export default client;
